import React from 'react'

export function DelayQuoteTips(props: 
  {
    hk_cn: boolean,
    hk_overseas: boolean 
  }
) {
  return (
    <div>
      {props.hk_cn && (
        <div className="hk-tips">
          未登录用户仅可查看港股延时15分钟行情 <a href="https://mpassport.eastmoney.com/login">去登录</a>
        </div>
      )}
      {props.hk_overseas && <div className="hk-tips">非中国大陆用户仅可查看港股延时15分钟行情</div>}
    </div>
  )
}
